export default __webpack_public_path__ + "static/media/trash-can.2bd67e98.png";